import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigRetailer";
import Constant from "../../constants";
import { Multiselect } from "multiselect-react-dropdown";
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import "../../public/css/retailer/retailer_style.css";
import RetailerHeader from "../retailer/RetailerHeader";
import RetailerSideMenu from "../retailer/RetailerSideMenu";
import * as SecureLS from "secure-ls";
import constants from "../../constants";
var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});
const moment = require("moment");

export default class RetailerOffers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      errors: {},
      retailerId: "",
      productOptions: [],
      selectedProducts: [],
      categoryOptions: [],
      selectedCategories: [],
      start_date: null,
      end_date: null,
      offer_images: [],
      logo: [],
      isSubmitting: false,
    };
  }

  setStartTimeOnChange = (value) => {
    this.setState({ start_date: value });
  };

  setEndTimeOnChange = (value) => {
    this.setState({ end_date: value });
  };

  componentDidMount = () => {
    const { handle } = this.props.match.params;
    let userData = ls.get("retuserObj");
    if (userData && userData !== "") {
      this.setState({ retailerId: userData.retailer_id });
      this.fetchCategoryList(userData.retailer_id);
    } else {
      window.location.href = "/retailer/login";
      return;
    }
    if (handle) this.getOfferInfo(handle);
  };

  fetchCategoryList(entity_id) {
    Httpconfig.httptokenpost(
      constants.siteurl + "api/productcategory/categorylist",
      { page: 1, limit: 100, entity_id: entity_id }
    ).then((response) => {
      const categories = (response.data.data || []).map((cat) => ({
        id: cat.id,
        name: cat.category_name,
      }));
      this.setState({ categoryOptions: categories });
    });
  }

  searchProducts = (searchText = "") => {
    Httpconfig.httptokenpost(
      constants.siteurl + "api/OM/MedicineDetails/medicinesearchbyretailerid",
      { retailer_id: this.state.retailerId, medicine_name: searchText, page: 1, limit: 20 }
    ).then((response) => {
      const products = (response.data.result || []).map((prod) => ({
        id: prod.id,
        medicinename: prod.medicinename,
        packaging_detail: prod.packaging_detail,
        manufacturer: prod.manufacturer,
        displayLabel: prod.packaging_detail
          ? `${prod.medicinename} (${prod.packaging_detail})`
          : prod.medicinename,
      }));
      this.setState({ productOptions: products });
    });
  };

  handleChange = (field, event) => {
    let fields = this.state.fields;
    fields[field] = field === "offer_name"
      ? event.target.value.toUpperCase()
      : event.target.value;
    this.setState({ fields });
  };

  getOfferInfo(handle) {
    Httpconfig.httptokenpost(
      Constant.siteurl + "api/productsoffers/getofferslist",
      { offer_id: handle }
    )
      .then((response) => {
        const offer = Array.isArray(response.data.data)
          ? response.data.data[0]
          : response.data.data;

        let imagesArr = [];
        try { imagesArr = offer.offer_images ? JSON.parse(offer.offer_images) : []; } catch (e) {}

        let logoArr = [];
        try {
          logoArr = offer.logo
            ? (typeof offer.logo === "string" ? JSON.parse(offer.logo) : offer.logo)
            : [];
        } catch (e) {}

        let discountValue = offer.discount_value;
        if (offer.rule_details) {
          try {
            const rule = typeof offer.rule_details === "string"
              ? JSON.parse(offer.rule_details)
              : offer.rule_details;
            discountValue = rule.discount || offer.discount_value;
          } catch (e) {}
        }

        const selectedCategories = (offer.offer_mappings || [])
          .filter((m) => m.category && m.category.id)
          .map((m) => ({ id: m.category.id, name: m.category.category_name }));

        const selectedProducts = (offer.offer_mappings || [])
          .filter((m) => m.product && m.product.id)
          .map((m) => ({
            id: m.product.id,
            medicinename: m.product.medicinename,
            packaging_detail: m.product.packaging_detail,
            manufacturer: m.product.manufacturer,
            displayLabel: m.product.packaging_detail
              ? `${m.product.medicinename} (${m.product.packaging_detail})`
              : m.product.medicinename,
          }));

        this.setState({
          fields: {
            offer_name: offer.offer_name,
            offer_type: offer.offer_type ? offer.offer_type.toLowerCase() : "",
            description: offer.description,
            discount_value: discountValue,
            applicable_to: offer.applicable_to,
          },
          start_date: offer.start_date ? new Date(offer.start_date) : null,
          end_date: offer.end_date ? new Date(offer.end_date) : null,
          retailerId: offer.entity_id,
          offer_images: imagesArr,
          logo: logoArr,
          selectedCategories,
          selectedProducts,
        });
      })
      .catch(() => toast.error("Failed to load offer info"));
  }

  handleValidation() {
    const fields = this.state.fields;
    const errors = {};
    let formIsValid = true;

    if (!fields["offer_name"]) {
      formIsValid = false;
      errors["offer_name"] = "Offer name cannot be empty";
    }
    if (!fields["offer_type"]) {
      formIsValid = false;
      errors["offer_type"] = "Offer type cannot be empty";
    }
    if (!fields["description"]) {
      formIsValid = false;
      errors["description"] = "Description cannot be empty";
    }
    if (fields["discount_value"] === undefined || fields["discount_value"] === null || fields["discount_value"] === "") {
      formIsValid = false;
      errors["discount_value"] = "Discount value cannot be empty";
    } else if (Number(fields["discount_value"]) < 0) {
      formIsValid = false;
      errors["discount_value"] = "Discount cannot be negative";
    }
    if (!this.state.start_date) {
      formIsValid = false;
      errors["start_date"] = "Start Date cannot be empty";
    }
    if (!this.state.end_date) {
      formIsValid = false;
      errors["end_date"] = "End Date cannot be empty";
    }
    if (!fields["applicable_to"]) {
      formIsValid = false;
      errors["applicable_to"] = "Applicable To is required";
    } else if (fields["applicable_to"] === "Products") {
      if (!this.state.selectedProducts || this.state.selectedProducts.length === 0) {
        formIsValid = false;
        errors["product_ids"] = "At least one product must be selected";
      }
    } else if (fields["applicable_to"] === "Categories") {
      if (!this.state.selectedCategories || this.state.selectedCategories.length === 0) {
        formIsValid = false;
        errors["category"] = "At least one category must be selected";
      }
    }
    // "ALL" means the offer applies globally — no specific selection required

    this.setState({ errors });
    return formIsValid;
  }

  checkSubmit = (event) => {
    event.preventDefault();
    if (!this.handleValidation()) {
      toast.warn("Form has errors. Please check all required fields.");
      return;
    }
    const { handle } = this.props.match.params;
    this.setState({ isSubmitting: true }, () => {
      if (handle) {
        this.updateOffers();
      } else {
        this.createOffer();
      }
    });
  };

  buildPayload() {
    const { fields, offer_images, selectedCategories, selectedProducts, logo, retailerId, start_date, end_date } = this.state;
    return {
      offer_name: fields["offer_name"],
      offer_type: fields["offer_type"],
      description: fields["description"],
      rule_details: JSON.stringify({ discount: fields["discount_value"] }),
      applicable_to: fields["applicable_to"],
      discount_value: fields["discount_value"] || 0,
      start_date: start_date instanceof Date && !isNaN(start_date) ? moment(start_date).format("YYYY-MM-DD") : "",
      end_date: end_date instanceof Date && !isNaN(end_date) ? moment(end_date).format("YYYY-MM-DD") : "",
      status: 1,
      retailer_id: retailerId,
      offer_images: offer_images || [],
      category_ids: selectedCategories.map((cat) => cat.id),
      product_ids: selectedProducts.map((prod) => prod.id),
      logo: logo || [],
    };
  }

  createOffer = () => {
    Httpconfig.httptokenpost(Constant.siteurl + "api/productsoffers/", this.buildPayload())
      .then((response) => {
        if (response.data.status === 200 && !response.data.error) {
          toast.success("Successfully Created Offer");
          setTimeout(() => this.props.history.push("/retailer/ViewRetailerOffers"), 1000);
        } else {
          toast.error("Offer already exists!!");
        }
      })
      .catch(() => toast.error("Failed to create offer"))
      .finally(() => this.setState({ isSubmitting: false }));
  };

  updateOffers = () => {
    const { handle } = this.props.match.params;
    Httpconfig.httptokenput(Constant.siteurl + "api/productsoffers/" + handle, this.buildPayload())
      .then((response) => {
        if (response.data.status === 200 && !response.data.error) {
          toast.success("Successfully Updated Offer");
          setTimeout(() => this.props.history.push("/retailer/ViewRetailerOffers"), 1000);
        } else {
          toast.error("Offer already exists!!");
        }
      })
      .catch(() => toast.error("Failed to update offer"))
      .finally(() => this.setState({ isSubmitting: false }));
  };

  handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    let loaded = 0;
    const newImages = [];
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        newImages.push({ image_url: reader.result });
        loaded++;
        if (loaded === files.length) {
          this.setState((prev) => ({ offer_images: [...(prev.offer_images || []), ...newImages] }));
        }
      };
      reader.readAsDataURL(file);
    });
  };

  handleLogoUpload = (event) => {
    const files = Array.from(event.target.files);
    let loaded = 0;
    const newLogos = [];
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        newLogos.push({ image_url: reader.result });
        loaded++;
        if (loaded === files.length) {
          this.setState((prev) => ({ logo: [...(prev.logo || []), ...newLogos] }));
        }
      };
      reader.readAsDataURL(file);
    });
  };

  removeImage = (idx) => {
    const newImages = [...this.state.offer_images];
    newImages.splice(idx, 1);
    this.setState({ offer_images: newImages });
  };

  removeLogo = (idx) => {
    const newLogos = [...this.state.logo];
    newLogos.splice(idx, 1);
    this.setState({ logo: newLogos });
  };

  render() {
    const { fields, errors, isSubmitting } = this.state;
    const applicableTo = fields["applicable_to"];

    return (
      <main id="main">
        <RetailerHeader />
        <RetailerSideMenu />
        <section id="main_dashboard" className="col-md-offset-2" style={{ marginLeft: "180px" }}>
          <div className="container-fluid" id="main_front">
            <div className="row">
              <div className="col-md-10">
                <section id="CMS_tab">
                  <div className="CMS_content create_calender">
                    <div className="container">
                      <div className="row">
                        <div className="tab-header">
                          <h3>{this.props.match.params.handle ? "Update Offer Management" : "Create Offer Management"}</h3>
                        </div>
                        <div id="reg_form">
                          <form onSubmit={this.checkSubmit}>
                            {/* Row 1: Offer Name + Category */}
                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="custom-control-label">Offer Name</label>
                                  <input
                                    type="text"
                                    name="offer_name"
                                    value={fields["offer_name"] || ""}
                                    onChange={this.handleChange.bind(this, "offer_name")}
                                    className="form-control"
                                    placeholder="Offer Name"
                                  />
                                  <span className="cRed">{errors["offer_name"]}</span>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="custom-control-label">Category</label>
                                  <Multiselect
                                    options={this.state.categoryOptions || []}
                                    displayValue="name"
                                    selectedValues={this.state.selectedCategories || []}
                                    onSelect={(list) => this.setState({ selectedCategories: list })}
                                    onRemove={(list) => this.setState({ selectedCategories: list })}
                                    placeholder="Select Categories"
                                    showCheckbox={true}
                                    closeOnSelect={false}
                                    style={{ chips: { background: "#007bff", color: "#fff" } }}
                                  />
                                  <span className="cRed">{errors["category"]}</span>
                                </div>
                              </div>
                            </div>

                            {/* Row 2: Offer Type + Description */}
                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="custom-control-label">Offer Type</label>
                                  <select
                                    name="offer_type"
                                    value={fields["offer_type"] || ""}
                                    onChange={this.handleChange.bind(this, "offer_type")}
                                    className="form-control"
                                  >
                                    <option value="">Select Offer Type</option>
                                    <option value="flat">Flat</option>
                                    <option value="percentage">Percentage</option>
                                  </select>
                                  <span className="cRed">{errors["offer_type"]}</span>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="custom-control-label">Description</label>
                                  <textarea
                                    name="description"
                                    value={fields["description"] || ""}
                                    onChange={this.handleChange.bind(this, "description")}
                                    className="form-control"
                                    placeholder="Offer Description"
                                  />
                                  <span className="cRed">{errors["description"]}</span>
                                </div>
                              </div>
                            </div>

                            {/* Row 3: Start Date + End Date */}
                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="custom-control-label">Start Date</label>
                                  <DatePicker
                                    name="start_date"
                                    autoComplete="off"
                                    className="dateInput"
                                    placeholderText="Start Date"
                                    popperPlacement="bottom"
                                    minDate={new Date()}
                                    selected={this.state.start_date instanceof Date && !isNaN(this.state.start_date) ? this.state.start_date : null}
                                    onChange={this.setStartTimeOnChange}
                                    dateFormat="yyyy-MM-d"
                                    showMonthDropdown
                                    adjustDateOnChange
                                  />
                                  <span className="cRed">{errors["start_date"]}</span>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="custom-control-label">End Date</label>
                                  <DatePicker
                                    name="end_date"
                                    autoComplete="off"
                                    className="dateInput"
                                    placeholderText="End Date"
                                    popperPlacement="bottom"
                                    minDate={new Date()}
                                    selected={this.state.end_date instanceof Date && !isNaN(this.state.end_date) ? this.state.end_date : null}
                                    onChange={this.setEndTimeOnChange}
                                    dateFormat="yyyy-MM-d"
                                    showMonthDropdown
                                    adjustDateOnChange
                                  />
                                  <span className="cRed">{errors["end_date"]}</span>
                                </div>
                              </div>
                            </div>

                            {/* Row 4: Applicable To + Discount Value */}
                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="custom-control-label">Applicable To</label>
                                  <select
                                    name="applicable_to"
                                    value={fields["applicable_to"] || ""}
                                    onChange={this.handleChange.bind(this, "applicable_to")}
                                    className="form-control"
                                  >
                                    <option value="">Select</option>
                                    <option value="ALL">All</option>
                                    <option value="Products">Products</option>
                                    <option value="Categories">Categories</option>
                                  </select>
                                  <span className="cRed">{errors["applicable_to"]}</span>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="custom-control-label">Discount Value</label>
                                  <input
                                    type="number"
                                    name="discount_value"
                                    value={fields["discount_value"] || ""}
                                    onChange={this.handleChange.bind(this, "discount_value")}
                                    className="form-control"
                                    placeholder="Discount Value"
                                  />
                                  <span className="cRed">{errors["discount_value"]}</span>
                                </div>
                              </div>
                            </div>

                            {/* Row 5: Products (shown when applicable_to is Products or ALL) */}
                            {(applicableTo === "Products" || applicableTo === "ALL") && (
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="form-group">
                                    <label className="custom-control-label">Products</label>
                                    <Multiselect
                                      options={this.state.productOptions || []}
                                      displayValue="displayLabel"
                                      selectedValues={this.state.selectedProducts || []}
                                      onSelect={(list) => this.setState({ selectedProducts: list })}
                                      onRemove={(list) => this.setState({ selectedProducts: list })}
                                      onSearch={(text) => this.searchProducts(text)}
                                      placeholder="Search & Select Products"
                                      showCheckbox={true}
                                      closeOnSelect={false}
                                    />
                                    <span className="cRed">{errors["product_ids"]}</span>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Row 6: Offer Images + Logo */}
                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="custom-control-label" style={{ fontWeight: "bold" }}>Offer Images</label>
                                  <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginBottom: "8px", background: "#f8f9fa", padding: "10px", borderRadius: "8px", minHeight: "50px" }}>
                                    {this.state.offer_images && this.state.offer_images.length > 0
                                      ? this.state.offer_images.map((img, idx) => (
                                          <div key={idx} style={{ position: "relative", border: "1px solid #e0e0e0", borderRadius: "8px", padding: "4px", background: "#fff" }}>
                                            <img src={img.url || img.image_url} alt="Offer" style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "6px" }} />
                                            <button
                                              type="button"
                                              style={{ position: "absolute", top: "-8px", right: "-8px", background: "#dc3545", color: "#fff", border: "none", borderRadius: "50%", width: "22px", height: "22px", cursor: "pointer", fontSize: "14px" }}
                                              onClick={() => this.removeImage(idx)}
                                            >&times;</button>
                                          </div>
                                        ))
                                      : <span style={{ color: "#888", fontSize: "13px" }}>No images uploaded.</span>
                                    }
                                  </div>
                                  <input type="file" name="offer_images" multiple accept="image/*" className="form-control" onChange={this.handleImageUpload} />
                                  <span className="cRed">{errors["offer_images"]}</span>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="custom-control-label" style={{ fontWeight: "bold" }}>Logo</label>
                                  <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginBottom: "8px", background: "#f8f9fa", padding: "10px", borderRadius: "8px", minHeight: "50px" }}>
                                    {this.state.logo && this.state.logo.length > 0
                                      ? this.state.logo.map((logoItem, idx) => (
                                          <div key={idx} style={{ position: "relative", border: "1px solid #e0e0e0", borderRadius: "8px", padding: "4px", background: "#fff" }}>
                                            <img src={logoItem.url || logoItem.image_url} alt="Logo" style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "6px" }} />
                                            <button
                                              type="button"
                                              style={{ position: "absolute", top: "-8px", right: "-8px", background: "#dc3545", color: "#fff", border: "none", borderRadius: "50%", width: "22px", height: "22px", cursor: "pointer", fontSize: "14px" }}
                                              onClick={() => this.removeLogo(idx)}
                                            >&times;</button>
                                          </div>
                                        ))
                                      : <span style={{ color: "#888", fontSize: "13px" }}>No logos uploaded.</span>
                                    }
                                  </div>
                                  <input type="file" name="logo" multiple accept="image/*" className="form-control" onChange={this.handleLogoUpload} />
                                  <span className="cRed">{errors["logo"]}</span>
                                </div>
                              </div>
                            </div>

                            {/* Save / Cancel — outside all multiselect dropdowns */}
                            <div className="row" style={{ position: "relative", zIndex: 10 }}>
                              <div className="form-group col-md-12">
                                <button
                                  type="submit"
                                  className="btn btn-primary save_btn"
                                  disabled={isSubmitting}
                                >
                                  {isSubmitting ? "Saving..." : "Save Offer"}
                                </button>
                                &nbsp;
                                <Link to="/retailer/ViewRetailerOffers" className="cancel_btn">
                                  Cancel
                                </Link>
                              </div>
                            </div>
                          </form>
                        </div>
                        <ToastContainer />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}
